import * as React from 'react';
import * as _ from 'underscore';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { appStore } from '../../AppStore';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { CreateScheduleAction } from '../Explorer/CreateContent/CreateContentActionsList';
import { SpaceHeaderWithTotalItemsCount } from '../Header/SpaceHeaderWithTotalItemsCount';

export interface AllSchedulesSpaceOwnProps extends ReactDirectiveProps {}

export interface AllSchedulesSpaceAngularProps {
  readonly browserTitleService: BrowserTitleService;
  readonly telemetry: Telemetry;
}

export interface AllSchedulesSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedSchedules: number;
}

export interface AllSchedulesSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllSchedulesSpaceNonAngularProps = AllSchedulesSpaceOwnProps & AllSchedulesSpaceStateProps & AllSchedulesSpaceDispatchProps;
export type AllSchedulesSpaceProps = AllSchedulesSpaceAngularProps & AllSchedulesSpaceNonAngularProps;

export class AllSchedulesSpace extends React.PureComponent<AllSchedulesSpaceProps> {
  public componentDidMount() {
    this.props.browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.schedules() });
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.schedules()}
          testId={'schedules'}
          count={this.props.numberOfFetchedSchedules}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list']}
            telemetry={this.props.telemetry}
            toolbarProps={{
              supportFilterPanel: false,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: newScheduleButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.schedulesEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }
}

export function newScheduleButton(): JSX.Element {
  const appState = appStore.getState();
  const createScheduleAction = CreateScheduleAction;
  if (createScheduleAction.isVisible(appState, 'schedules') && createScheduleAction.isClickable()) {
    const reduxAction = createScheduleAction.createReduxAction();
    const handleClick = () => appStore.dispatch(reduxAction);
    return (
      <ButtonWidget
        children={createScheduleAction.title()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        tb-test-id={'action-create-new-schedule'}
        testId={'action-create-new-schedule'}/>
    );
  }
  return null;
}
